import { TwilioAccountModel, TwilioPhoneNumberModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface TwilioAccountContextType {
  twilioAccount: TwilioAccountModel | undefined;
  isConnected: boolean;
  isTwilioConfigLoading: boolean;
  listPhoneNumbers: (params: {
    sid: string;
    token: string | null;
  }) => Promise<TwilioPhoneNumberModel[]>;
  isListingPhoneNumbers: boolean;
  connectTwilioAccount: (params: {
    sid: string;
    token: string;
    phone_number: string;
    phone_number_sid: string;
  }) => Promise<TwilioAccountModel>;
  isConnectingTwilioAccount: boolean;
  changeTwilioPhone: (params: {
    phone_number: string;
    phone_number_sid: string;
  }) => Promise<TwilioAccountModel>;
  isChangingTwilioPhone: boolean;
  disconnectTwilioAccount: () => Promise<void>;
  isDisconnectingTwilioAccount: boolean;
}

export const TwilioAccountContext =
  createContext<TwilioAccountContextType | null>(null);
